import React from 'react';
import { Link } from 'react-router-dom';
import OxfordBusiness from 'components/Cards/OxfordBusiness';
import './Oxford.css';
import { useTranslation } from 'react-i18next';
import GlobalStore from 'stores/globalStore';

const Oxford: React.FC = () => {
  const { bookData } = GlobalStore.useContainer();
  const { t } = useTranslation();

  return (
    <>
      <h2 className="course__title">ELSA Oxford Business Result</h2>
      <div className="oxfords">
        {bookData.oxford.map((oxford, index) => (
          <div className="oxford__item" key={index}>
            <OxfordBusiness product={oxford} />
          </div>
        ))}
      </div>
      <div className="nav__mobile">
        <p className="nav__mobile__title">{t('courses.see_more_package')}:</p>
        <Link to="/course/harper-collins">
          <button className="nav__mobile__btn">ELSA by Harper Collins</button>
        </Link>
      </div>
    </>
  );
};

export default Oxford;
